/* Shared STL bundle selector for the store's Dawn 12 variant-selects/variant-radios.
 * Install only with the matching Liquid snippet. No cart interception or price overrides.
 */
(() => {
  "use strict";
  const marker = document.querySelector("[data-kc-shared-stl]");
  if (!marker) return;
  let config;
  try { config = JSON.parse(marker.textContent); } catch { return; }
  const allowedIds = new Set(config.variantIds.map(String));
  const attached = new WeakSet();
  const downloadName = "STL Download Bundle";
  const isDownload = v => v.option1 === downloadName && v.requires_shipping === false;

  function attach(picker) {
    if (attached.has(picker) || typeof picker.getVariantData !== "function") return;
    let variants;
    try { variants = picker.getVariantData(); } catch { return; }
    if (!variants.length || !variants.every(v => allowedIds.has(String(v.id)))) return;
    const downloads = variants.filter(isDownload);
    const wrappers = [...picker.querySelectorAll(".product-form__input")];
    if (!downloads.length || wrappers.length !== 2 ||
        variants.some(v => v.options.length !== 2) ||
        downloads.some(v => v.price !== downloads[0].price)) return;
    attached.add(picker);
    const second = wrappers[1];
    const originalDisplay = second.style.display;
    const hint = document.createElement("p");
    hint.className = "product__text kc-shared-stl-note";
    hint.setAttribute("role", "status");
    hint.textContent = "Includes all listed sizes and styles. Digital files only; no physical item is shipped.";
    hint.hidden = true;
    picker.insertAdjacentElement("afterend", hint);
    const valueOf = wrapper => wrapper.querySelector("select")?.value ??
      wrapper.querySelector('input[type="radio"]:checked')?.value;
    const setValue = (wrapper, value) => {
      const select = wrapper.querySelector("select");
      if (select) {
        if (![...select.options].some(o => o.value === value)) return false;
        select.value = value;
      } else {
        const radio = [...wrapper.querySelectorAll('input[type="radio"]')].find(r => r.value === value);
        if (!radio) return false;
        radio.checked = true;
      }
      return true;
    };
    let lastPhysicalSecond = valueOf(wrappers[0]) === downloadName ? null : valueOf(second);
    let wasDigital = valueOf(wrappers[0]) === downloadName;

    function synchronize() {
      const firstValue = valueOf(wrappers[0]);
      const oldSecond = valueOf(second);
      const digital = firstValue === downloadName;
      let target;
      if (digital) {
        target = downloads.find(v => v.available && v.option2 === "Both included") ??
          downloads.find(v => v.available && v.option2 === oldSecond) ??
          downloads.find(v => v.available) ?? downloads[0];
      } else {
        const physical = variants.filter(v => !isDownload(v) && v.option1 === firstValue);
        const preferred = wasDigital ? lastPhysicalSecond : oldSecond;
        target = physical.find(v => v.option2 === preferred) ??
          physical.find(v => v.available) ?? physical[0];
      }
      // Fail open if the theme markup/options differ from the inspected version.
      if (!target || !setValue(second, target.option2)) {
        second.style.display = originalDisplay;
        hint.hidden = true;
        return false;
      }
      second.style.display = digital ? "none" : originalDisplay;
      hint.hidden = !digital;
      if (!digital) lastPhysicalSecond = target.option2;
      wasDigital = digital;
      return oldSecond !== target.option2;
    }

    // Capture runs before Dawn's existing change listener reads selected options.
    // Dawn continues to update price, availability, URL, media and the cart variant ID.
    picker.addEventListener("change", synchronize, true);
    if (synchronize()) picker.onVariantChange();
  }

  function scan() {
    document.querySelectorAll("variant-selects, variant-radios").forEach(attach);
  }
  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, {childList: true, subtree: true});
    document.addEventListener("shopify:section:load", scan);
  }
  Promise.all(["variant-selects", "variant-radios"].map(name => customElements.whenDefined(name)))
    .then(() => {
      if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, {once: true});
      else start();
    });
})();
